export default {
    getDefaultState() {
        return {
            loading: {
                sessionData: false,
            },

            dialogsVisible: {
                inactivityDialog: false,
                forcedDialog: false
            },

            logoutTimerVisible: false,

            noRefresh: false,

            formattedInactivityTime: null,
            formattedLogoutTime: null,

            sessionForcedExpirationTime: null,
            sessionExpirationTime: null,
            sessionTimer: null,
            warningTimer: null,

            forceStopWarningTimer: false
        }
    },
};
